<agr-form-dialog [formGroup]="formGroup" (confirm)="save()" (cancel)="cancel()" [data]="data">
  <span>{{ 'select-feed-advice-country.description' | translate }}</span>
  <div class="flex--column">
    <mat-form-field class="flex__child--auto spacing--margin-top">
      <mat-label>{{ 'select-feed-advice-country.label' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        formControlName="country"
        data-test="select-country"
      >
        <mat-option *ngFor="let country of data.countries" [value]="country">
          {{ getFeedadviceCountryLabel(country) }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</agr-form-dialog>
